<div class="innerContainer">
	<div class="provider-status-dashboard">
		<div class="font-weight-bold grpHeader"><a
				(click)="groupPortalDataService.navigateToRoute('members')">{{groupList.GroupInfo?.residencyDetail ?
				'Residents' : 'Providers'}} Status</a></div>
		<div class="divider"></div>
		<div class="statusChart widgetBodyContainer">
			<div class="piecontainer" id="piecontainer">

				<div class="svgpiechart d-flex  justify-content-around  mx-auto" id="mysvgpiechart">
					<svg viewBox="0 0 32 32" class="skypie" [ngClass]="(
						mbrCount?.ready > 0 ? 'capReady' :
							mbrCount?.pending > 0 ? 'capPending' :
								(mbrCount?.paid + mbrCount?.submitted)  > 0 ? 'capPaid' :
									mbrCount?.notInGB > 0 ? 'capNotin' : '')">
						<circle r="16" cx="16" cy="16" class="numberone ready" [ngStyle]="{
								'stroke-dasharray': mbrCount?.percentofPieSliceReadyForPayment + ' 100',
								'stroke-dashoffset':'0'}" />
						<circle r="16" cx="16" cy="16" class="numbertwo pending" [ngStyle]="{
							'stroke-dasharray': mbrCount?.percentofPieSlicePending + ' 100',
							'stroke-dashoffset': mbrCount?.strokeoffsetPending}" />
						<circle r="16" cx="16" cy="16" class="numberthree paid" [ngStyle]="{
							'stroke-dasharray': mbrCount?.percentofPieSlicePaid + ' 100',
							'stroke-dashoffset': mbrCount?.strokeoffsetPaid }" />
						<circle r="16" cx="16" cy="16" class="numberfour notinGB" [ngStyle]="{
							'stroke-dasharray': mbrCount?.percentofPieSliceNotInGB + ' 100',
							'stroke-dashoffset': mbrCount?.strokeoffsetNotInGB}" />
						<!-- <text x="50%" y="40%" name="totals" class="totals" fill="#333">{{mbrCount?.totalMembers}}</text>
						<text x="50%" y="100%" name="txtTotal" class="txtTotal" fill="#333">Total</text> -->
					</svg>
					<div class="insidetotals" id="thedonuthole">
						<div class="totals" id="donutholetotal">{{mbrCount?.totalMembers}}</div>
						<div class="txtTotal" id="txtdonutholetotal">Total</div>
					</div>

				</div>

				<!-- <div class="currentsvg" style="display:none;">
				<svg viewBox="0 0 32 32" class="skypie">
					<circle r="16" cx="16" cy="16" class="numberone" />
					<circle r="16" cx="16" cy="16" class="numbertwo" />
					<circle r="16" cx="16" cy="16" class="numberthree" />
					<circle r="16" cx="16" cy="16" class="numberfour" />
					<text x="50%" y="40%" name="totals" class="totals" fill="#333">{{(mbrCount?.pending + mbrCount?.ready + mbrCount?.paid)}}</text>
					<text x="50%" y="100%" name="txtTotal" class="txtTotal" fill="#333">Total</text>
				</svg>
			</div> -->

				<div class="breakdown pt-4 mb-0 d-flex flex-row">
					<div class="breakdowntotals d-flex flex-column  justify-content-start align-items-center w-100">
						<svg viewBox="0 0 32 32" class="svgone">
							<circle r="16" cx="16" cy="16" />
							<text x="50%" y="50%" name="breakdown-readyforpayment"
								fill="white">{{mbrCount?.ready}}</text>
						</svg>
						<span class="bubbletext pending">Ready for Payment</span>
					</div>

					<div class="breakdowntotals d-flex flex-column  justify-content-start align-items-center w-100">
						<svg viewBox="0 0 32 32" class="svgtwo">
							<circle r="16" cx="16" cy="16" />
							<text x="50%" y="50%" name="breakdown-pending" fill="white">{{mbrCount?.pending}}</text>
						</svg>
						<span class="bubbletext">Application Pending</span>
					</div>
					<div class="breakdowntotals d-flex flex-column  justify-content-start align-items-center w-100">
						<svg viewBox="0 0 32 32" class="svgthree">
							<circle r="16" cx="16" cy="16" />
							<text x="50%" y="50%" name="breakdown-paid" fill="white">{{mbrCount?.paid +
								mbrCount?.submitted}}</text>
						</svg>
						<span class="bubbletext">Paid Members</span>
					</div>

					<div class="breakdowntotals d-flex flex-column  justify-content-start align-items-center w-100">
						<svg viewBox="0 0 32 32" class="svgfour">
							<circle r="16" cx="16" cy="16" />
							<text x="50%" y="50%" name="breakdown-notinGP" fill="white">{{mbrCount?.notInGB}}</text>
						</svg>
						<span class="bubbletext">Not in Group Bill</span>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="widgetLoader {{showChart ? 'hidethis' : ''}}"></div>
</div>